import { render, staticRenderFns } from "./VacanciesRecruitment.vue?vue&type=template&id=976e10a0&scoped=true"
import script from "./VacanciesRecruitment.vue?vue&type=script&lang=js"
export * from "./VacanciesRecruitment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976e10a0",
  null
  
)

export default component.exports